module.exports = __webpack_public_path__ + "static/img/card02a@2x.69a4e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/card02a@2x.png
// module id = 414
// module chunks = 1